import {Injectable} from '@angular/core';
import {FacebookService} from 'ngx-facebook';
import {FBLogin, FBLoginStatusEnum} from '../fblogin';
import {isDifferentObject, getUserLocale} from './utils';
import {Observable} from 'rxjs/Observable';
import {AppService} from '../../../app.service';
import {FacebookAdsApi, AdAccount} from 'facebook-nodejs-ads-sdk';
import {NavigationStart, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

export const LoginUrl = '/auth';

export class BasedFBService {
  getAPI(access_token?: string, debug: boolean = false) {
    // TODO: localStorage에 access_token이 저장되어있지 않을때 적당한 에러처리
    const _ = localStorage.getItem('access_token');
    const locale = getUserLocale();
    const api = access_token ? new FacebookAdsApi(access_token, locale) : new FacebookAdsApi(_, locale);
    api.setDebug(debug);
    return api;
  }

  _adAccountObj(adAccountID: string) {
    return new AdAccount(adAccountID, {}, null, this.getAPI(null, true));
  }
}

export class BasedFBServiceContainsRespData extends BasedFBService {
  gens: RespDataGeneratorStorage;
  cpc: ChangedParamsChecker;


  constructor() {
    super();
    this.gens = new RespDataGeneratorStorage();
    this.cpc = new ChangedParamsChecker();
  }

  isChangedOpts(limit: number, funcName: string, params: object) {
    return limit === -1 || this.cpc.isChanged(funcName, Object.assign({}, params));
  }
}


@Injectable()
export class FBAPIInitService {
  fblogin: FBLogin;
  loginStatus = FBLoginStatusEnum.Authorized;
  isAuthUrl = true;

  constructor(public fb: FacebookService,
              private appService: AppService,
              private router: Router,
              private http: HttpClient) {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.isAuthUrl = event.url === LoginUrl;
        }
      });
    this.fblogin = new FBLogin(fb, router, http);
    this.validateLoginStatusLoop();
  }

  validateLoginStatusLoop(delayMS: number = 5000) {
    this.validateLoginStatus();
    setInterval(() => this.validateLoginStatus(), delayMS);
  }


  validateLoginStatus() {
    if (!this.isAuthUrl) {
      const access_token = localStorage.getItem('access_token');

      if (access_token)  {
        const access_token_expires_at = parseInt(localStorage.getItem('access_token_expires_at'), 0);
        if (access_token_expires_at === 0 || access_token_expires_at > new Date().getTime()) {
          this.loginStatus = FBLoginStatusEnum.Authorized;
        } else {
          this.loginStatus = FBLoginStatusEnum.Expired;
        }
      } else {
        this.loginStatus = FBLoginStatusEnum.NotLogin;
      }

      this.appService.enableCallAPI(this.isPossibleCallAPI());
      if (!this.isPossibleCallAPI()) {
        this.router.navigate([LoginUrl]);
      }
    }
  }

  isPossibleCallAPI(): boolean {
    return FBLoginStatusEnum.Authorized === this.loginStatus;
  }
}


export class RespDataGenerator {
  api: any;
  transDataFunc: any;
  apiCallCount: number;


  constructor(api: any, transDataFunc?: any) {
    this.api = api;
    this.transDataFunc = transDataFunc;
    this.apiCallCount = 0;
  }


  next(): Observable<any> {
    if (this.hasNext()) {
      const apiCall = Observable.fromPromise(this.api.next ? this.api.next() : this.api);
      this.apiCallCounter();
      return apiCall.map((res: any) => {
        const result = res.data ? res.data : res;
        return this.transDataFunc ? this.transDataFunc(result) : result;
      })
    } else {
      throw Observable.throw('no more data to get');
    }
  }

  hasNext(): boolean {
    return this.apiCallCount === 0 || (this.api.hasNext && this.api.hasNext());
  }

  apiCallCounter(): void {
    this.apiCallCount++;
  }
}


export class RespDataGeneratorStorage  {
  private _gen: Map<string, RespDataGenerator>;

  constructor() {
    this._gen = new Map<string, RespDataGenerator>();
  }
  get(key: string): RespDataGenerator {
    return this._gen[key];
  }
  set(key: string, value: RespDataGenerator): void {
    this._gen[key] = value;
  }
}

export class ChangedParamsChecker {
  before: object;

  constructor() {
    this.before = {};
  }

  isChanged(callerFuncName: string, params: object): boolean {
    const bool = isDifferentObject(this.before, params);
    this.before = params;
    return bool;
  }
}



// WEBPACK FOOTER //
// ./src/app/manager/shared/service/fbapi.ts